import React from 'react';
import { Form } from '../../../ui/universe';
import { TagInput, Tooltip } from 'tdesign-react';
import OcrTag from '../../../ui/Tag/index.jsx';
import { splitByCommas, removeLastByType } from '../../../../utils/index.js';

/**
 * 标签输入参数渲染器
 */
function InputTagRenderer({
  params,
  value,
  tags,
  defaultTags,
  currentKey,
  setCurrentKey,
  showConfirm,
  setShowConfirm,
  onChange
}) {
  return (
    <>
      {params.labelList?.map((label) => (
        <Form.Item
          key={label.KeyType}
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>{label.label}</span>
              {label.des && (
                <Tooltip content={label.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              )}
            </div>
          }
        >
          <TagInput
            value={tags}
            disabled={showConfirm}
            placeholder="输入字段名，多个字段用逗号分隔"
            excessTagsDisplayType="break-line"
            size="medium"
            onChange={(e, cur) => {
              if (cur.e.keyCode === 8 || cur.e.keyCode === 46) {
                const _val = removeLastByType(value, label.KeyType, 'KeyType');
                onChange(_val);
              } else {
                if (!e.length) return;
                const _curVal = splitByCommas(cur.item);
                const _val = value;
                _curVal.map((i) => {
                  _val.push({
                    KeyName: i,
                    KeyType: label.KeyType,
                    KeyPrompt: ''
                  });
                });
                onChange(_val);
              }
            }}
            onClear={() => {
              const _val = value.filter((i) => i.KeyType !== label.KeyType);
              onChange(_val);
            }}
            valueDisplay={({ value: displayTags }) =>
              displayTags?.map((item, index) => {
                if (value[index]?.KeyType !== label.KeyType) {
                  return null;
                }
                return (
                  <OcrTag
                    key={index}
                    keyVal={index}
                    currentKey={currentKey}
                    maxPrompt={params.KeyPromptMax}
                    keyPrompt={value[index]?.KeyPrompt}
                    onConfirm={(val) => {
                      const _val = value;
                      _val[index].KeyPrompt = val.KeyPrompt;
                      onChange(_val);
                    }}
                    onChoose={(e) => {
                      setCurrentKey(e);
                    }}
                    setShowConfirm={(val) => {
                      setShowConfirm(val);
                      if (!val) {
                        setCurrentKey(null);
                      }
                    }}
                    content={item}
                    theme={defaultTags.includes(item) ? 'star' : 'primary'}
                    onClose={() => {
                      value.splice(index, 1);
                      onChange(value);
                    }}
                  />
                );
              })
            }
            clearable
          />
        </Form.Item>
      ))}
    </>
  );
}

export default InputTagRenderer;
